<div class="tt-c-ask-tips">
  <div v-for="col in columns" class="tt-c-ask-tips__col">
    <div v-if="col.title" class="tt-c-ask-tips__heading" v-html="col.title"></div>
      <ol v-if="col.tag === 'ol'" class="tt-c-ask-tips__list">
        <li v-for="item in col.items" class="tt-c-ask-tips__list-item" v-html="item"></li>
      </ol>
      <ul v-if="col.tag === 'ul'" class="tt-c-ask-tips__list">
        <li v-for="item in col.items" class="tt-c-ask-tips__list-item" v-html="item"></li>
      </ul>
      <p v-if="col.tag === 'p'" v-for="item in col.items" class="tt-c-ask-tips__text" v-html="item"></p>
  </div>
</div>
  


// WEBPACK FOOTER //
// ./src/components/ask/ask-tips.html